export const enum commentConstants{
    getCommentsListRequest="GET_COMMENTS_LIST_REQUEST",
    getCommentsListSuccess="GET_COMMENTS_LIST_SUCCESS",
    getCommentsListFailure="GET_COMMENTS_LIST_FAILURE",

    addCommentRequest="ADD_COMMENT_REQUEST",
    addCommentSuccess="ADD_COMMENT_SUCCESS",
    addCommentFailure="ADD_COMMENT_FAILURE",

    editCommentRequest="EDIT_COMMENT_REQUEST",
    editCommentSuccess="EDIT_COMMENT_SUCCESS",
    editCommentFailure="EDIT_COMMENT_FAILURE",
}